import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { useNavigate } from 'react-router-dom';

const CreateSubPage = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState([]);
  const [selectedPage, setSelectedPage] = useState('');
  const [subPageName, setSubPageName] = useState('');

  useEffect(() => {
    const fetchPages = async () => {
      try {
        const response = await api.get('/pages');
        setPages(response.data);
      } catch (error) {
        console.error('Error fetching pages:', error);
        alert('Failed to fetch pages');
      }
    };

    fetchPages();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('pageId', selectedPage);
    formData.append('subpageName', subPageName);

    try {
      const response = await api.post('/subpages', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      if (response.status === 201 || response.status === 200) {
        alert(`Subpage '${response.data.subpage}' created successfully!`);
        setSelectedPage('');
        setSubPageName('');
        navigate('/manage-subpage');
      } else {
        alert('Failed to create subpage. Please try again.');
      }
    } catch (error) {
      console.error('Error creating subpage:', error);
      alert('Error creating subpage');
    }
  };

  const handleCancel = () => {
    setSelectedPage('');
    setSubPageName('');
    navigate('/manage-subpage');
  };

  return (
    <div className='container mt-5'>
      <form onSubmit={handleSubmit}>
        <div className="col-sm-6">
          <div>
            <label className="mb-1">Select Page</label>
            <select
              className="form-control mb-3"
              value={selectedPage}
              onChange={(e) => setSelectedPage(e.target.value)}
            >
              <option value="">Select Page</option>
              {pages.map((page) => (
                <option key={page.id} value={page.id}>
                  {page.name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="mb-1">Enter Subpage Name</label>
            <input
              type="text"
              className="form-control mb-3"
              value={subPageName}
              onChange={(e) => setSubPageName(e.target.value)} 
            />
          </div>

          <div className="button-group">
            <button type="submit" className="btn btn-success submit-button">Submit</button>
            <button type="button" className="btn btn-danger cancel-button" onClick={handleCancel}>Cancel</button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateSubPage;
